import { useTranslation } from "react-i18next";
import buildingImg from "../assets/images/building.webp";
import globalCircleImg from "../assets/images/global-circle.webp";
import React, { useEffect, useRef, useState } from "react";
import a_1 from "../assets/images/a_1.png";
import a_2 from "../assets/images/a_2.png";
import a_3 from "../assets/images/a_3.png";
import a_4 from "../assets/images/a_4.png";
import a_5 from "../assets/images/a_5.png";
import a_6 from "../assets/images/a_6.png";
import "./AboutSection.scss";
import GradientText from "../repo/GradientText";
import CountUp from "../repo/CountUp";
import Orb from "../repo/Orb";
import SpotlightCard from "../repo/SpotlightCard";
import useIntersectionAnimation from "../hooks/useIntersectionAnimation";

const AboutSection = ({ onBusinessCardClick }) => {
  const { t } = useTranslation();
  // 记录上一次滚动位置
  const lastScrollTopRef = useRef(0);
  // 获取目标元素ref
  const headerTopRef = useRef(null);
  // 使用通用 Hook，自定义延迟时间（150ms）
  const setAnimationRef = useIntersectionAnimation(150);
  const cardData = [
    {
      title: t("about.longTermTitle"),
      desc: t("about.longTermDesc"),
    },
    {
      title: t("about.certaintyTitle"),
      desc: t("about.certaintyDesc"),
    },
    {
      title: t("about.opportunitiesTitle"),
      desc: t("about.opportunitiesDesc"),
    },
  ];

  useEffect(() => {
    // 滚动监听函数
    const handleScroll = () => {
      const currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const headerTop = headerTopRef.current;

      if (!headerTop) return;

      // 向下滚动且滚动距离超过50px
      if (
        currentScrollTop > lastScrollTopRef.current &&
        currentScrollTop > 1400
      ) {
        headerTop.classList.add("expand");
      } else {
        // 可选：向上滚动恢复原高度
        // headerTop.classList.remove("expand");
      }

      lastScrollTopRef.current = currentScrollTop <= 0 ? 0 : currentScrollTop;
    };

    // 添加滚动监听
    window.addEventListener("scroll", handleScroll);
    // 组件卸载时移除监听
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className='about-section'>
      {/* 1. 头部ABOUT US区域 */}
      <div className='about-header' id={t("navbar.about")}>
        {/* <div ref={headerTopRef} className='about-header-top'></div> */}
        <div className='g-inner section-inner header-section-inner'>
          <h2 className='section-title sub-font'>{t("about.headerTitle")}</h2>
          <p className='text-sm about-header-text sub-font'>
            {t("about.headerDesc")}
          </p>
        </div>
      </div>

      {/* 2. 图片+文字两列区域 */}
      <div className='about-two-col content-overlay-dark'>
        <div className='section-inner about2-section-inner'>
          <div className='two-col-wrap'>
            <div className='col-img'>
              <img src={buildingImg} alt={t("about.buildingAlt")} />
            </div>
            <div className='col-text'>
              <p className='text-sm sub-font'>{t("about.believeTitle")}</p>
              <p
                className='text-xs mt-1 sub-font'
                dangerouslySetInnerHTML={{ __html: t("about.believeDesc1") }}
              ></p>
              <p
                className='text-xs mt-2 sub-font'
                dangerouslySetInnerHTML={{ __html: t("about.believeDesc2") }}
              ></p>
            </div>
          </div>
        </div>
      </div>

      {/* 3. 使命板块 */}
      <div className='about-mission content-overlay-dark'>
        <div className='section-inner g-inner'>
          <div className='mission-top'>
            <p className='text-xs sub-font'
                dangerouslySetInnerHTML={{ __html: t("about.missionDesc") }}></p>
            <div className='mission-text-wrap'>
              <GradientText
                colors={["#806B42", "#F3E3CA", "#D0B487"]}
                animationSpeed={3}
                showBorder={false}
                className='custom-class'
              >
                <p className='sub-slogan'>{t("about.subSlogan")}</p>
              </GradientText>
            </div>
            {/* <img src={aboutSImg} alt={t("about.buildingAlt")} /> */}
          </div>
          <p className='text-sm mt-2 notice sub-font'>
            {t("about.missionNotice")}
          </p>
          <div className='mission-cards mt-4'>
            {cardData.map((card, index) => (
              <div
                key={index}
                className='mission-card animation-item'
                ref={(el) => setAnimationRef(el, index)}
              >
                <p className='text-sm sub-font'>{card.title}</p>
                <p className='text-xs mt-1 sub-font'>{card.desc}</p>
              </div>
            ))}
            {/* <div className='mission-card'>
              <p className='text-sm'>{t("about.longTermTitle")}</p>
              <p className='text-xs mt-1'>{t("about.longTermDesc")}</p>
            </div>
            <div className='mission-card'>
              <p className='text-sm'>{t("about.certaintyTitle")}</p>
              <p className='text-xs mt-1'>{t("about.certaintyDesc")}</p>
            </div>
            <div className='mission-card'>
              <p className='text-sm'>{t("about.opportunitiesTitle")}</p>
              <p className='text-xs mt-1'>{t("about.opportunitiesDesc")}</p>
            </div> */}
          </div>
        </div>
      </div>

      {/* 4. 全球布局+成立年份 */}
      <div className='about-global content-overlay-dark'>
        <div className='section-inner g-inner'>
          <div className='global-wrap'>
            <div className='global-left'>
              <div>
                <h3 className='section-global-title sub-font'>
                  {t("about.globalTitle")}
                </h3>
                <p className='text-xs mt-1 sub-font'>{t("about.globalDesc")}</p>
              </div>
              <div className='founded mt-4'>
                <p className='text-sm smaller sub-font'>
                  {t("about.foundedTitle")}
                </p>
                <div className='founded-year mt-1 sub-font'>
                  <GradientText
                    colors={["#806B42", "#F3E3CA", "#D0B487"]}
                    animationSpeed={3}
                    showBorder={false}
                    className='custom-class'
                  >
                    {t("about.foundedYear")}
                  </GradientText>
                </div>
              </div>
            </div>
            <div className='global-right'>
              <div className='circle-box'>
                {/* <img
                  src={globalCircleImg}
                  alt={t("about.globalCircleAlt")}
                  className='circle-img'
                /> */}

                <div className='orb-wrapper'>
                  <Orb
                    hoverIntensity={0.5}
                    rotateOnHover={true}
                    hue={0}
                    forceHoverState={false}
                  ></Orb>
                </div>
                <div className='circle-text'>
                  <p className='title'>{t("about.apacRegionTitle")}</p>
                  <p className='text-xs value sub-font'>
                    {t("about.apacRegion")}
                  </p>
                  <p className='title'>{t("about.middleEastTitle")}</p>
                  <p className='text-xs mt-1 value sub-font'>
                    {t("about.middleEastRegion")}
                  </p>

                  <p className='title'>{t("about.europeAmericasTitle")}</p>
                  <p className='text-xs mt-1 value sub-font'>
                    {t("about.europeAmericasRegion")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 5. 业务板块 */}
      <div className='about-business content-overlay-dark'>
        <div className='section-inner g-inner'>
          <h3 className='section-title sub-font'>{t("about.businessTitle")}</h3>
          <div className='business-cards mt-2'>
            <SpotlightCard
              className='business-card'
              spotlightColor='rgba(190, 156, 7, 0.5)'
              onClick={() => onBusinessCardClick(1)}
            >
              <img src={a_1} alt={t("equity.focus1Alt")} className='card-img' />

              <p className=' mt-1'>{t("about.privateEquity")}</p>
            </SpotlightCard>
            <SpotlightCard
              className='business-card'
              spotlightColor='rgba(190, 156, 7, 0.5)'
            >
              <img src={a_2} alt={t("equity.focus1Alt")} className='card-img' />
              <p className=' mt-1'>{t("about.fixedIncome")}</p>
            </SpotlightCard>{" "}
            <SpotlightCard
              className='business-card'
              spotlightColor='rgba(190, 156, 7, 0.5)'
            >
              <img src={a_3} alt={t("equity.focus1Alt")} className='card-img' />
              <p className=' mt-1'>{t("about.commoditySupply")}</p>
            </SpotlightCard>
          </div>
        </div>
      </div>

      {/* 6. 投资理念 */}
      <div className='about-philosophy content-overlay-dark'>
        <div className='section-inner g-inner'>
          <h3 className='section-title sub-font'>
            {t("about.philosophyTitle")}
          </h3>
          <div className='philosophy-cards mt-2'>
            <SpotlightCard
              className='philosophy-card'
              spotlightColor='rgba(190, 156, 7, 0.5)'
            >
              <img src={a_4} alt={t("equity.focus1Alt")} className='card-img' />
              <p className=' mt-1'>{t("about.industryFinance")}</p>
            </SpotlightCard>

            <SpotlightCard
              className='philosophy-card'
              spotlightColor='rgba(190, 156, 7, 0.5)'
            >
              <img src={a_5} alt={t("equity.focus1Alt")} className='card-img' />
              <p className=' mt-1'>{t("about.globalPerspective")}</p>
            </SpotlightCard>

            <SpotlightCard
              className='philosophy-card'
              spotlightColor='rgba(190, 156, 7, 0.5)'
            >
              <img src={a_6} alt={t("equity.focus1Alt")} className='card-img' />
              <p className=' mt-1'>{t("about.longTermism")}</p>
            </SpotlightCard>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
